<template>
  <article class="heslb-card">
    <div class="heslb-card__header">
      <div>
        <cabinet-status :status="loan.status" />
        <h2>{{ loan.account_reference_masked }}</h2>
      </div>
      <strong>{{ formatMoney(loan.current_balance, loan.currency) }}<span>{{ $t('heslb.balance') }}</span></strong>
    </div>
    <div class="heslb-card__progress"><span :style="{ width: `${progress}%` }"></span></div>
    <cabinet-rows :rows="rows" />
    <button v-if="loan.deductions.length" class="cabinet-disclosure" type="button" @click="expanded = !expanded">
      {{ expanded ? $t('common.hideDeductions') : $t('common.deductionsCount', { count: loan.deductions.length }) }}
    </button>
    <cabinet-schedule v-if="expanded" :items="schedule" />
  </article>
</template>

<script>
import CabinetRows from './CabinetRows'
import CabinetSchedule from './CabinetSchedule'
import CabinetStatus from './CabinetStatus'
import { formatMoney, formatMonth, progressPercent } from './cabinetDisplay'

export default {
  name: 'HeslbCard',
  components: { CabinetRows, CabinetSchedule, CabinetStatus },
  props: {
    loan: {
      type: Object,
      required: true,
    },
  },
  data() {
    return { expanded: false }
  },
  computed: {
    progress() {
      return progressPercent(this.loan.deducted_amount, this.loan.initial_amount)
    },
    rows() {
      return [
        { label: this.$t('heslb.initial'), value: formatMoney(this.loan.initial_amount, this.loan.currency) },
        { label: this.$t('heslb.deducted'), value: formatMoney(this.loan.deducted_amount, this.loan.currency) },
        { label: this.$t('heslb.currentBalance'), value: formatMoney(this.loan.current_balance, this.loan.currency) },
      ]
    },
    schedule() {
      return this.loan.deductions.map(item => ({
        month: formatMonth(item.month),
        status: item.status,
        amount: formatMoney(item.amount, this.loan.currency),
      }))
    },
  },
  methods: { formatMoney },
}
</script>

<style lang="sass" scoped>
.heslb-card
  padding: 20px
  border: 1px solid #e5e5e5
  border-radius: 14px

.heslb-card + .heslb-card
  margin-top: 16px

.heslb-card__header
  display: flex
  align-items: flex-start
  justify-content: space-between
  gap: 15px

  h2
    margin-top: 8px
    color: #202020
    font-size: 20px
    font-weight: 600

  > strong
    color: #4f8d12
    font-size: 19px
    font-weight: 600
    text-align: right

    span
      display: block
      font-size: 16px

.heslb-card__progress
  height: 8px
  margin: 17px 0 4px
  overflow: hidden
  border-radius: 6px
  background-color: #e7ece2

  span
    display: block
    height: 100%
    border-radius: inherit
    background-color: $color-theme

.cabinet-disclosure
  margin-top: 14px
  color: #4f8d12
  font-size: 14px
  font-weight: 600

.cabinet-schedule
  margin-top: 10px
</style>
